import {qs} from '../utils/dom.js';
import {navigateToOffer} from '../utils/navigation.js';
import {appState} from '../state/app-state.js';

export function renderBonus() {
  const mount = qs("#bonus");
  if (!mount) return;


  const welcome = appState.offer?.bonuses?.welcome_bonus;
  if (welcome) {
    // Update only the value spans to avoid visible "swap" of whole sentences
    const spans = mount.querySelectorAll("[data-bonus-value]");
    spans.forEach((span) => {
      const current = (span.textContent || "").trim();
      // Replace only placeholders/empty values
      if (current === "" || current === "…" || current === "...") {
        span.textContent = welcome;
      }
    });
  }

  const action = qs('.bonusButton');
  const textLinks = mount.querySelectorAll('.bonusTextLink');
  if (appState.offer) {
    action.setAttribute("href", `/casino/${appState.offer.id}`);
    textLinks.forEach((link) => {
      link.setAttribute("href", `/casino/${appState.offer.id}`);
      link.onclick = (ev) => {
        ev.preventDefault();
        navigateToOffer(appState.offer.id, appState.offer.link);
      };
    });
  }
  action.textContent = "Claim bonus";
  action.onclick = (ev) => {
    ev.preventDefault();
    if (appState.offer) {
      navigateToOffer(appState.offer.id, appState.offer.link);
    }
  };

}
